import * as types from './AuditlogsActionType';

export const fetchRadiologistAllDDListRequest = () => ({
    type: types.FETCH_RADIOLOGIST_ALL_DDLIST_REQUEST
});
export const fetchRadiologistAllDDListSuccess = (data) => ({
    type: types.FETCH_RADIOLOGIST_ALL_DDLIST_SUCCESS,
    payload: data
});
export const fetchRadiologistAllDDListFailure = (error) => ({
    type: types.FETCH_RADIOLOGIST_ALL_DDLIST_FAILURE,
    payload: error
});

// Export Audit Logs
export const exportAuditLogsRequest = (filterData) => ({
    type: types.EXPORT_AUDIT_LOGS_REQUEST,
    payload: filterData
});
export const exportAuditLogsSuccess = (data) => ({
    type: types.EXPORT_AUDIT_LOGS_SUCCESS,
    payload: data
}); 
export const exportAuditLogsFailure = (error) => ({
    type: types.EXPORT_AUDIT_LOGS_FAILURE,
    payload: error
}); 

export const fetchGetAllModuleFieldActionTypeDropdownRequest = () => ({
    type: types.GetAllModuleFieldActionTypeDropdown_REQUEST,
});
export const fetchGetAllModuleFieldActionTypeDropdownSuccess = (data) => ({
    type: types.GetAllModuleFieldActionTypeDropdown_SUCCESS,
    payload: data
});
export const fetchGetAllModuleFieldActionTypeDropdownFailure = (error) => ({
    type: types.GetAllModuleFieldActionTypeDropdown_FAILURE,
    payload: error
});


export const exportAuditLogsAllListRequest = (payload) => ({
    type: types.GetAllAuditLogsList_REQUEST,
    payload: payload
});
export const exportAuditLogsAllListSuccess = (data) => ({
    type: types.GetAllAuditLogsList_SUCCESS,
    payload: data
}); 
export const exportAuditLogsAllListFailure = (error) => ({
    type: types.GetAllAuditLogsList_FAILURE,
    payload: error
}); 


export const GetAuditLogscustomReportRequest = (payload) => ({
    type: types.GETALLAUDITLOGCUSTOMREPORT_REQUEST,
    payload: payload
});
export const GetAuditLogscustomReportSuccess = (data) => ({
    type: types.GETALLAUDITLOGCUSTOMREPORT_SUCCESS,
    payload: data
}); 
export const GetAuditLogscustomReportFailure = (error) => ({
    type: types.GETALLAUDITLOGCUSTOMREPORT_FAILURE,
    payload: error
}); 

export const exportAuditLogscustomRequest = (filterData) => ({
    type: types.EXPORTAUDITLOGCUSTOMREPORT_REQUEST,
    payload: filterData
});
export const exportAuditLogscustomSuccess = (data) => ({
    type: types.EXPORTAUDITLOGCUSTOMREPORT_SUCCESS,
    payload: data
}); 
export const exportAuditLogscustomFailure = (error) => ({
    type: types.EXPORTAUDITLOGCUSTOMREPORT_FAILURE,
    payload: error
}); 